export default "__VITE_ASSET__DcfwKNZV__"